<template>
  <VRadioGroup
    class="int-radio-group"
    v-model="noticeMethod"
  >
    <slot name="title">
      <div class="int-radio-text">
        {{ $t('howToNotice') + ':' }}
      </div>
    </slot>
    <VRadio
      v-for="method in noticeMethods"
      :value="method.value"
      :label="method.label"
      :key="method.value"
    />
  </VRadioGroup>
</template>
<script>
import { candidateNotificationTypes } from '@/enums';
import { computed, toRefs } from '@vue/composition-api';
import { useI18n } from 'vue-i18n-composable';

export default {
  name: 'CandidateInviteMethods',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const { t } = useI18n();
    const noticeMethods = [
      {
        value: candidateNotificationTypes.EMAIL,
        label: 'Email',
      },
      {
        value: candidateNotificationTypes.SMS,
        label: 'Email + SMS',
      },
      {
        value: candidateNotificationTypes.CALL,
        label: `Email + SMS + ${t('call')}`,
      },
    ];

    return {
      noticeMethods,
      noticeMethod: computed({
        get() {
          return value.value;
        },
        set(val) {
          emit('input', val);
        },
      }),
    };
  },
};
</script>
<style lang="scss" scoped>
.int-radio-group {
  border-radius: 0.25rem;
  padding: 0 0 0.25rem 0;
  margin-top: -0.875rem ;
}
.int-radio-item {
  color: #091A35;
  border: 1px solid #fff;
  border-radius: 0.25rem;
  padding: 1.25rem;
  background: #EEF3FA;
  &_active {
    background-color: #fff;
    border-color: transparent;
  }
}
.int-radio-text {
  color: #091A35;
  font-weight: bold;
  line-height: 1.53;
  margin-bottom: 1rem;
}
</style>

<i18n locale="en" lang="yml">

</i18n>
<i18n locale="ru" lang="yml">
howToNotice: Как оповещать кандидатов
call: Звонок роботом
</i18n>
